// extracted by mini-css-extract-plugin
export var cardSelected = "_gu-2";
export var image = "_gu-1";
export var table = "_gu-0";